import { Icon, Tooltip } from '@ksyos/design-system';
import type { ServiceCode } from '@common/enums';
import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { getSelectedLanguage } from '@frontend/translate';

type ServiceToolTipProps = {
    reason: ServiceForSelectedServiceType['reason'];
    serviceCode: ServiceCode;
};

export function ServiceTooltip({ serviceCode, reason }: ServiceToolTipProps) {
    if (!reason) {
        return null;
    }
    const translate = getSelectedLanguage();

    // Translations are not typed and there is no index signature.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const serviceTranslations: any = translate.unavailableServices;
    const serviceCodeLower = serviceCode.toLowerCase();

    const tooltipText = serviceTranslations[serviceCodeLower]?.[reason].alertAndTooltip;

    return tooltipText ? (
        <Tooltip
            content={tooltipText}
            placement="bottom"
        >
            <Icon
                icon="information"
                sx={{ ml: 2 }}
            />
        </Tooltip>
    ) : null;
}
